var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"items":_vm.contentItems,"chips":"","clearable":"","deletable-chips":"","multiple":"","small-chips":"","item-text":"title","item-value":"id"},on:{"input":_vm.handleInput},model:{value:(_vm.selectedContent),callback:function ($$v) {_vm.selectedContent=$$v},expression:"selectedContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }